import React, { useEffect, useState } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isPointer, setIsPointer] = useState(false);

  useEffect(() => {
    const updatePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const updateCursor = (e) => {
      const target = e.target;
      setIsPointer(
        window.getComputedStyle(target).cursor === 'pointer' ||
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.closest('button') !== null ||
        target.closest('a') !== null
      );
    };

    window.addEventListener('mousemove', updatePosition);
    window.addEventListener('mouseover', updateCursor);

    return () => {
      window.removeEventListener('mousemove', updatePosition);
      window.removeEventListener('mouseover', updateCursor);
    };
  }, []);

  return (
    <>
      <div
        className="fixed pointer-events-none z-[9999] mix-blend-difference"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div
          className={`bg-cyan-400 rounded-full transition-all duration-150 ${
            isPointer ? 'w-12 h-12 opacity-20' : 'w-4 h-4 opacity-100'
          }`}
          style={{
            boxShadow: isPointer
              ? '0 0 30px rgba(0, 188, 212, 0.8)'
              : '0 0 10px rgba(0, 188, 212, 0.5)'
          }}
        />
      </div>
      <div
        className="fixed pointer-events-none z-[9998]"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div
          className="w-8 h-8 border-2 border-cyan-400 rounded-full opacity-50"
          style={{
            animation: 'cursorPulse 1s ease-out infinite',
            transition: 'all 0.3s ease-out'
          }}
        />
      </div>
    </>
  );
};

export default CustomCursor;
